import styled from "styled-components";

export const VersionMantenimientoContainer = styled.div`
width:100%;`;
export const VersionMantenimientoHeader = styled.div`
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(257.94deg, #027bc0 18.65%, #004b76 86.55%);
  border-radius: 8px 8px 0 0;
`;
export const VersionMantenimientoBody = styled.div`
  padding: 36px;
`;
